import { getKycStatus } from '@services/external/auth.api';
import { useQuery } from 'react-query';

async function handler() {
  const { data } = await getKycStatus();
  return data;
}

function useKycStatus() {
  return useQuery(['kyc:status'], handler);
}

export default useKycStatus;
